import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=31b98755&scoped=true&"
import script from "./Bag.vue?vue&type=script&lang=js&"
export * from "./Bag.vue?vue&type=script&lang=js&"
import style0 from "./Bag.vue?vue&type=style&index=0&id=31b98755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b98755",
  null
  
)

export default component.exports